export const Routes = {
	HOME: '/',
	WELCOME: '/welcome',
	DASHBOARD: '/dashboard',

	AML_ROOT: '/aml',
	AML_DASHBOARD: '/aml/dashboard',
	AML_SCREENING: '/aml/screening',
	AML_SCREENING_RESULTS: '/aml/screening/results',
	AML_ALERTS: '/aml/screening/alerts',
	AML_ALERT_DETAIL: '/aml/screening/alerts/:id',
	AML_WHITELIST: '/aml/screening/alerts/whitelist',
	AML_CASE_MANAGER: '/aml/screening/case-manager',
	AML_CASE_DETAIL: '/aml/screening/cases/:id',
	AML_CONFIG: '/aml/screening/config',
	AML_ADMIN: '/aml/admin',
	AML_THRESHOLDS: '/aml/settings/thresholds',
	AML_RATIONALE: '/aml/screening/admin/rationale',
	AML_MANUAL_SCREENING: '/aml/screening/manual',
	AML_WATCHLIST_SEARCH: '/aml/watchlist/search',
	AML_WATCHLIST_INGESTION: '/aml/watchlist/ingestion',
	AML_SCREENING_SCHEDULE: '/aml/screening/schedule',
	AML_STR: '/aml/str',

	// Backoffice-aligned URLs
	RR_CASE_MANAGER: '/risk-radar/case-manager',
	RR_CASE_DETAIL: '/risk-radar/case-manager/:id',
	NS_MANUAL_SCREENING: '/name-screening/manual-screening',
	NS_WATCHLIST_SEARCH: '/name-screening/watchlist-search',
	NS_WATCHLIST_INGESTION: '/name-screening/watchlist-ingestion',
	NS_SCREENING_SCHEDULE: '/name-screening/screening-schedule',
	NS_BATCH_SCREENING: '/name-screening/batch-screening',
	NS_THRESHOLD: '/name-screening/threshold',
	NS_CONFIG: '/name-screening/config',

	CONNECTRA_ROOT: '/connectra',
	CONNECTRA_DASHBOARD: '/connectra/dashboard',
	CONNECTRA_CONNECTIONS: '/connectra/connections',
	CONNECTRA_COMMUNICATIONS: '/connectra/communications',
	CONNECTRA_CLIENT: '/connectra/client',

	USERS_ROOT: '/users',
	USERS_LIST: '/users/list',
	USERS_PROFILE: '/users/profile',

	GMC_ROOT: '/gmc',
	GMC_CONFIGS: '/gmc/configs',
	GMC_LOGS: '/gmc/logs',
} as const;

export type RouteValue = (typeof Routes)[keyof typeof Routes];
